import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import ObjectOverride from "components/ObjectOverride";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";


/**
 *  @property {Events_Object} state
 *  @property {object} model
 *  @property {Events_Properties} model.properties
 *  @property {Events_Is} model.is
 *  @property {Events_Has} model.has
 */
export default class EventObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Events._name);
		this.state.date_error = false;
	}

	/**
	 * @param prevProps
	 * @param {Events_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Events_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name);
		}
	}


	handleSubmit = () => {
		let d1 = new Date(this.state.start);
		let d2 = new Date(this.state.end);
		if(d1 > d2) {
			this.setState({date_error: true})
		}
		else {
			super.handleSubmit();
		}
	}

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	// async afterSubmit(data, request, suppressProcess = false) {
	// 	if (typeof this.props.setNewObject === 'function') {
	// 		this.props.setNewObject(data);
	// 	}
	// };


	ignoreWarning = (warningName) => () => {
		this.setState({
			[warningName]: false
		});
	};


	form = () => {
		/** @type {Events_Properties} properties */
		let properties = this.model.properties;
		/** @type {Events_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					{this.state.date_error &&
						<WarningAlert
							onAlertDismiss={this.ignoreWarning('date_error')}
							warningName={'Start Date Later Than End Date'}
							warningMessage={'The start date cannot be after the end date.'}
						/>}
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">Event</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Event Name"}
									value={object.name}
									error={object.name_error}
									property={properties.name}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={'row'}>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.DateTime
											label={"Start Date"}
											property={properties.start}
											value={object.start}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.DateTime
											label={"End Date"}
											property={properties.end}
											value={object.end}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

						</div>

						<div className={"col-md"}>
							<h4 className="section-title">Address</h4>
							<Parts.Address
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								hasCounty={true}
							/>
						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
